import React from 'react'

export default function ImagePreview({imageFile}) {
    const {name, original_download_url} = imageFile
    return (
          <img src={original_download_url} alt={name} />
      )
}
